import type { PublicSlotKey } from '#packages/apilib';
import type { BreakpointsApi } from './breakpointsApi';

export const BreakpointsApiKey: PublicSlotKey<BreakpointsApi> = {
  name: 'BreakpointsApi',
  public: true,
};
